import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  IBaseConfigurationFormModel,
  IFormbuilderFieldTypeConfiguration,
} from '../../../models/form-builder-types-configurations.model';
import {
  generateNewFieldKeyFromSettingsLabel,
  getFieldKeySettingsConfigFormly,
  getFieldLabelSettingsConfigFormly,
} from '../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { FormBuilderService } from '../../../services/form-builder.service';
import { IFormFieldsDisplayModel } from '../../../models/form-fields-formly-display.model';
import { parseFieldIntoDisplayFormModel } from '../form-fields-formly-display/form-fields-formly-display-field-parse-to-model.util';
import { setDisplayHideExpressionFromModel } from '../form-fields-formly-display/form-fields-formly-display-field-set-from-model.util';
import { getFieldDisplayFormConfig } from '../form-fields-formly-display/form-fields-formly-display-field-generator.util';

export const defaultSectionConfigFormModel: IBaseConfigurationFormModel = {
  fieldKey: '',
  fieldLabel: '',
};

export const sectionFieldGetConfigurationConfig = (
  formBuilderServiceInstance: FormBuilderService
): IFormbuilderFieldTypeConfiguration => {
  return {
    settings: {
      formModel: defaultSectionConfigFormModel,
      formlyForm: [
        ...getFieldLabelSettingsConfigFormly(formBuilderServiceInstance),
        ...getFieldKeySettingsConfigFormly(formBuilderServiceInstance),
      ],
    },
    display: {
      formModel: {},
      formlyForm: [...getFieldDisplayFormConfig(formBuilderServiceInstance)],
    },
  };
};

export const sectionFieldParseIntoSettingsFormModel = (
  field: FormlyFieldConfig
): IBaseConfigurationFormModel => {
  const model: IBaseConfigurationFormModel = {
    fieldKey: (field.key as string) ?? '',
    fieldLabel: field.props?.label ?? '',
  };

  return model;
};

export const sectionFieldUpdateFromSettingsFormModel = (
  model: IBaseConfigurationFormModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  if (field.props) {
    field.props['label'] = model.fieldLabel ?? undefined;
  } else {
    field['props'] = {
      label: model.fieldLabel ?? undefined,
    };
  }

  // Handle field key update
  if (model.fieldKey && model.fieldKey.trim() !== '') {
    // Use the provided field key
    field.key = model.fieldKey.trim();
  } else if (!field.key || model.fieldLabel !== field.props?.['label']) {
    // Auto-generate key from label if no key provided or label changed
    field = generateNewFieldKeyFromSettingsLabel(field);
  }

  return field;
};

export const sectionFieldParseFieldIntoDisplayFormModel = (
  field: FormlyFieldConfig
): IFormFieldsDisplayModel => {
  return parseFieldIntoDisplayFormModel(field);
};

export const sectionFieldUpdateFromDisplayFormModel = (
  model: IFormFieldsDisplayModel,
  field: FormlyFieldConfig
): FormlyFieldConfig => {
  return setDisplayHideExpressionFromModel(model, field);
};
